import { atom } from "jotai";

export const recentInsertsAtom = atom<boolean | { error: string; showError: boolean } | null>(false);